module.exports = __webpack_public_path__ + "static/media/loc6_img1.5036aa99.jpg";